import { render, staticRenderFns } from "./dialog-tagversion.vue?vue&type=template&id=b4a2cc94&"
import script from "./dialog-tagversion.vue?vue&type=script&lang=js&"
export * from "./dialog-tagversion.vue?vue&type=script&lang=js&"
import style0 from "./dialog-tagversion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports